import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';

export const canPartyBeDeleted = (
  allParties: Pick<IParty, 'purpose'>[],
  thisParty: Pick<IParty, 'purpose'>
): boolean => {
  const purpose = thisParty.purpose;

  switch (purpose) {
    case ePartyPurpose.borrower:
    case ePartyPurpose.buyer:
      return allParties.filter((t) => t.purpose === purpose).length > 1;
    case ePartyPurpose.seller:
      return true;
  }
  return false;
};
